import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjectProposalById } from "../../../../redux/project/action";
import SignJobContract from "./SignJobContract";
import { formatNumberWithCommas, getMemberSince, today } from "../../../Common/AllDateTimeReleventFormate";
import { storage } from "../../../../Firebase/config";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import html2canvas from "html2canvas";
import RoleLabel from "../../../Common/RoleLabel";
import ClientUserCommonDetails from "../../../Common/ClientUserCommonDetails";
import ContractView from "../../../CustomComponents/ContractView";

export default function ProjectContract() {
  const path = "Assets/scss/FindWork.module.scss";
  const location = useLocation();
  const { state } = location;
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();

  const { id } = useParams();
  const pbi = useSelector(
    ({ project: { getprojectproposalbyid } }) => getprojectproposalbyid,
  );
  const dispatch = useDispatch();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);

  useEffect(() => {
    dispatch(getProjectProposalById(id));
  }, [id]);

  const movesomewhere = () => {
    if (state?.its == "hiring") {
      navigate(`/${lan}/expertsprofiledetails/${state?.expert_id}`)
    }
    else {
      navigate(-1)
    }
  }

  return (
    <div className="container-fluid contract">
      <div className="project-offer project-details col-lg-10 mx-auto">
        {/* <p className="breadcrumbs">
          {state?.approvefrom == 'user' ? <a onClick={() => navigate(-2)}>My work &gt; </a> : <a onClick={() => navigate(-2)}>Manage orders &gt; </a>}
          <a onClick={() => navigate(-1)}>Job proposal &gt;</a> {state?.approvefrom == "user" ? "Accept offer" : "Send offer"}
        </p> */}
        {/* {JSON.stringify(state)} */}
        {/* //Profile Details */}
        {
          state?.its == 'hiring' ? <>
            <p className="breadcrumbs">
              <a onClick={() => movesomewhere(-1)}>{pbi?.is_mine == 1 ? "Manage Work" : state?.its == 'hiring' ? "Profile Details" : "All Proposal"} &gt; </a>
              {pbi?.is_mine == 1 ? "Offer" : "Offer"}
            </p>
          </> : <>
            <p className="breadcrumbs">
              <a onClick={() => navigate(-2)}>{pbi?.is_mine == 1 ? "Manage Work" : "My Order"} &gt; </a>
              <a onClick={() => navigate(-1)}>{pbi?.is_mine == 1 ? "PTJ Details" : "All Proposal"} &gt; </a>
              {pbi?.is_mine == 1 ? "Offer" : "Submit Proposal"}
            </p>
          </>
        }
        {/* <p className="breadcrumbs">
          <a onClick={() => movesomewhere(-1)}>{pbi?.is_mine == 1 ? "Manage Work" : state?.its == 'hiring' ? "Profile Details" : "All Proposal"} &gt; </a>
          {pbi?.is_mine == 1 ? "Offer" : "Offer"}
        </p> */}
        <div id='take-screenshot-for-this-form' className="col-lg-10 mx-auto">
          <div className="contract-sec" id="capture-contract-section">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
              alt=""
            />
            <div className="flex-sec">
              <p>Date : {getMemberSince(today)}</p>
              <p>ID : {pbi?.agreement_id}</p>
            </div>
            <div className="website-design">
              {
                pbi?.direct_hiring == 1 ?
                  <ContractView type={'hiring_agreement'} />
                  :
                  <ContractView type={'job_agreement'} />
              }
              {/* <ContractView type={'job_agreement'} /> */}
            </div>
            <div className="project-details">
              <div className="flex-sec">
                <p>Job Details</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p>Price</p>
                <p>$ {formatNumberWithCommas(pbi?.price)}</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p>Hiring Type</p>
                <p>
                  {pbi?.hiring_type == 1
                    ? "Hourly"
                    : pbi?.hiring_type == 3
                      ? "Weekly"
                      : pbi?.hiring_type == 4
                        ? "Monthly"
                        : ""}
                </p>
              </div>
              <div className="flex-sec flex-sec1">
                <p>Work Location</p>
                <p>
                  {pbi?.work_location == 1
                    ? "Virtual"
                    : pbi?.work_location == 2
                      ? "Physical"
                      : ""}
                </p>
              </div>
              {pbi?.work_location == 2 ? (
                <div className="flex-sec flex-sec1">
                  <p>City</p>
                  <p>{posts?.city_name}</p>
                </div>
              ) : (
                ""
              )}
            </div>
            <ClientUserCommonDetails pbi={pbi} />
            <SignJobContract pbi={pbi} />
          </div>
        </div>
      </div>
    </div>
  );
}
